import React from 'react';

const HorizontalSeparator = () => {
  return <div className="w-2" />;
};

export default HorizontalSeparator;
